module.exports = __webpack_public_path__ + "static/img/FJ@2x.a0995db5.jpg";